<app-header [tiny]="true">
  <a
    appButton
    name="DONTREPORT"
    location="asset-header"
    [iconButton]="true"
    color="hard-simple"
    height="1"
    (click)="close()"
    shape="round"
    class="back"
    [appTooltip]="'Back to Gallery'"
    tooltipKeyboardShortcut="ESC"
    toolTipOrigin="right"
  >
    <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
  </a>
  <app-asset-page-meta
    [asset]="asset()"
    [thumbnailBarOpen]="thumbnailBarOpen()"
    [gallery]="gallery()"
    (onThumbnailBarOpen)="onThumbnailBarOpen.emit($event)"
  >
  </app-asset-page-meta>
  <div class="spacer"></div>
  <div class="right-buttons">
    @if (clientMode()) {
      @if (user() || guest()?.email) {
        <app-context-menu [options]="{ width: '320px', noSpacing: true }" #menu>
          <div
            appClickTrack
            name="profile-circle"
            location="asset-header"
            class="profile-circle"
            appTooltip="Your Profile"
            data-test-id="profile-circle"
            [class.auto-border]="(user() | avatarType) === 'image'"
            contextButton
          >
            <app-avatar [user]="user() || guest()"></app-avatar>
          </div>
          <app-view-profile-menu
            [gallery]="gallery()"
            [galleryPermissions]="galleryPermissions()"
            contextContent
            (onClose)="menu.close()"
          ></app-view-profile-menu>
        </app-context-menu>
      } @else if (galleryPermissions()?.can_review_if_authenticated) {
        <div
          class="profile-circle"
          appTooltip="Your Profile"
          data-test-id="profile-circle"
          [class.auto-border]="(user() | avatarType) === 'image'"
          (click)="openGuestProfileDialog()"
        >
          <app-avatar [user]="user() || guest()"></app-avatar>
        </div>
      }
    }
    <app-context-menu
      class="guest-info"
      [options]="{ width: '233px' }"
      verticalPosition="bottom"
      position="center"
      #anonymousGuestInfo
    >
      <div contextContent (click)="anonymousGuestInfo.close(); openGuestProfileDialog()" class="guest-info-content">
        You left feedback anonymously. Click here to add your info and let others know who you are.
      </div>
    </app-context-menu>

    @if (!clientMode() && galleryPermissions().can_edit) {
      <app-context-menu [options]="{ width: '380px', noSpacing: true }" #activityMenu>
        <button
          appButton
          contextButton
          name="activity"
          location="edit-gallery-header"
          color="hard-simple"
          [iconButton]="true"
          shape="round"
          data-test-id="gallery-activity"
          weight="bold"
          height="1"
          heightMobile="0-5"
          appTooltip="Show activity"
        >
          <app-svg src="/assets/icons/bolt.svg"></app-svg>
        </button>

        <div contextContent>
          @if (activityMenu.isOpen()) {
            <app-asset-activity-menu
              [gallery]="gallery()"
              [asset]="asset()"
              (closeContext)="activityMenu.close()"
            ></app-asset-activity-menu>
          }
        </div>
      </app-context-menu>
    } @else if (allowDownload()) {
      <app-asset-download-button
        location="asset-header"
        [asset]="asset()"
        [gallery]="gallery()"
        [galleryPermissions]="galleryPermissions()"
        [downloadTemplate]="true"
      >
        <button
          appButton
          name="download"
          location="asset-header"
          [iconButton]="true"
          shape="round"
          color="hard-simple"
          height="1"
        >
          <app-svg src="/assets/icons/download.svg"></app-svg>
        </button>
        <button
          appButton
          name="download"
          location="asset-header"
          [iconButton]="true"
          shape="round"
          color="hard-simple"
          height="1"
          downloadingContent
        >
          <app-loading-indicator downloadingContent size="small" color="white"> </app-loading-indicator>
        </button>
      </app-asset-download-button>
    }

    @if (!clientMode() && galleryPermissions().can_edit) {
      <app-context-menu [options]="{ width: '240px', noSpacing: true }" #assetContextMenu [position]="'right'">
        <button
          appButton
          name="options"
          location="asset-sidebar"
          [iconButton]="true"
          height="1"
          shape="round"
          color="hard-simple"
          appTooltip="More options"
          contextButton
          data-test-id="asset-sidebar-more"
          #button
        >
          <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
        </button>
        <div contextContent>
          @if (
            assetContextMenu.isOpen() ||
            (contextService.openContextMenus$ | async | inferredContextOpen: 'asset-' + asset().id)
          ) {
            <app-asset-context-menu
              [asset]="asset()"
              [gallery]="gallery()"
              [galleryPermissions]="galleryPermissions()"
              (onClose)="assetContextMenu.close()"
              (openShare)="openShareDialog()"
              (onDelete)="onDelete.emit()"
              (beforeDelete)="beforeDelete.emit()"
              (onNewVersion)="onUpload.emit()"
            >
            </app-asset-context-menu>
          }
        </div>
      </app-context-menu>
    }
    @if (gallery().save_camera_metadata || galleryPermissions().can_edit) {
      <button
        appButton
        name="info"
        location="asset-header"
        data-test-id="asset-info-button"
        [iconButton]="true"
        height="1"
        shape="round"
        color="hard-simple"
        (click)="onShowInfo.emit()"
        [appTooltip]="'Asset Information'"
        [toolTipOrigin]="'left'"
        [tooltipKeyboardShortcut]="'I'"
      >
        <app-svg src="/assets/icons/info-outline.svg"></app-svg>
      </button>
    } @else if (allowedAndEnabledFeedbackOptions().includes('comment')) {
      <button
        appButton
        name="comments"
        location="asset-header"
        data-test-id="asset-comments-button"
        [iconButton]="true"
        height="1"
        shape="round"
        color="hard-simple"
        (click)="onShowComments.emit()"
      >
        <app-svg src="/assets/icons/comment-bubble-outline.svg"></app-svg>
      </button>
    }
  </div>
</app-header>
